import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpClient) {}

  httpGet(url: string) {
    return this.http.get(url);
  }

  httpPost(url: string, {}: any) {
    return this.http.post(url, { name: "Subrat" });
  }

  sendEmail(api: string, data: any) {
    var url = `${environment.sendEmailUrl}/${api}`;
    return this.http.post(url, data);
  }
}
